module.exports = __webpack_public_path__ + "img/b1.3d0e82af.jpg";